import React from "react";
import "./About.css";

export default function About() {
  return (
    <section className="about-section">
      <div className="about-inner">

        {/* Left: Image */}
        <div className="about-image-wrap">
          <img
            src="/assets/about.jpeg"
            alt="About Ruga's Cafe"
            className="about-image"
          />
        </div>

        {/* Right: Text */}
        <div className="about-text">
          <h2>About Ruga's Café</h2>

          <p>
            Ruga’s Café is a local favourite serving fresh food, great coffee,
            and genuine community warmth. Our menu is built around classic
            flavours, handmade daily bakes, and simple ingredients done well.
          </p>

          <p>
            Whether you're grabbing breakfast on the go, settling in for a long
            lunch, or ordering for a group, we take pride in fast, friendly
            service every day.
          </p>

          <p>
            Come in, say hi, and feel at home — that’s what Ruga’s is all about.
          </p>
        </div>

      </div>
    </section>
  );
}
